import { useQuery } from '@tanstack/react-query';

import { useStoreApi } from '../api';
import { storeKeys } from '../query-key-factory';
import { ListUserDonatedActiveCampaignsResponse, SelectedCausesResponse } from './types';

const useListUserDonatedActiveCampaigns = () => {
  const StoreApi = useStoreApi();

  const getUserDonatedActiveCampaigns = async () => {
    const { data } =
      await StoreApi.get<ListUserDonatedActiveCampaignsResponse>('/consumer/fundraisers');

    return data.fundraisers;
  };

  return useQuery({
    queryFn: getUserDonatedActiveCampaigns,
    queryKey: storeKeys.id('user').consumer.fundraisers.all,
  });
};

const useListSelectedCausesInfo = () => {
  const StoreApi = useStoreApi();

  const getUserSelectedCauses = async () => {
    const { data } = await StoreApi.get<SelectedCausesResponse>('/consumer/selected_causes');
    return data.causes;
  };
  return useQuery({
    queryFn: getUserSelectedCauses,
    queryKey: storeKeys.id('user').consumer.selectedCauses.all,
  });
};

export { useListSelectedCausesInfo, useListUserDonatedActiveCampaigns };
